import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "d-flex text-center" }
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "flex-fill" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "color circle red" }
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]

import WidgetWebRtcCall from "~/chat/ts/service/webRtc/WidgetWebRtcCall";
import {__} from "~/ts/library/Translate";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import {computed, ref} from "vue";
import WebRtcCall from "~/core-ui/vue/chat/webrtc/WebRtcCall.vue";
import OperatorAvatar from "~/chat/vue/widget/tabs/chat/OperatorAvatar.vue";


const __default__ = {
    name: "WidgetWebRtcCallOverlay"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "0fc93c8a": (_unref(borderRadius))
}))


let borderRadius = ConfigStore.isMobile.value ? 0 : `${ConfigStore.design.value.borderRadius}px`;

let hasNewIncomingCalls = computed(() => WidgetWebRtcCall.incomingCalls.value.length > 0);

let fullScreen = ref(false);

function minimize() {
    WidgetWebRtcCall.toggleCallOverlay(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "zoom" }, {
    default: _withCtx(() => [
      (_unref(hasNewIncomingCalls) || _unref(WidgetWebRtcCall).isCallOverlayOpened())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({
                'absolute-full-size new-call d-flex flex-column': true,
                'widget-draggable-handler': !_unref(fullScreen),
                'fullscreen': _unref(fullScreen)
            })
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({'flex-fill': !_unref(WidgetWebRtcCall).isCallOverlayOpened()})
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass({
                    'flex-fill': _unref(WidgetWebRtcCall).isCallOverlayOpened(),
                    'w-100': true
                })
            }, [
              (_unref(hasNewIncomingCalls))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)("NEW_INCOMING_CALL")), 1),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                          class: "circle color green",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(WidgetWebRtcCall).incomingCalls.value[0].joinCall()))
                        }, [
                          _createVNode(SvgIcon, { "icon-name": "phone" })
                        ]),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(__)("REPLY")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                          class: "circle color red",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(WidgetWebRtcCall).incomingCalls.value[0].hangUp()))
                        }, [
                          _createVNode(SvgIcon, { "icon-name": "times" })
                        ]),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(__)("DECLINE")), 1)
                      ])
                    ])
                  ]))
                : (_unref(WidgetWebRtcCall).getCurrentCall())
                  ? (_openBlock(), _createBlock(WebRtcCall, {
                      key: 1,
                      class: "web-rtc-call",
                      call: _unref(WidgetWebRtcCall).getCurrentCall(),
                      "default-local-video-width": 150,
                      "default-local-video-height": 100,
                      "show-full-screen-button": !_unref(ConfigStore).isMobile.value,
                      "show-screen-button": !_unref(ConfigStore).isMobile.value,
                      "full-screen": _unref(fullScreen),
                      "onUpdate:fullScreen": _cache[2] || (_cache[2] = ($event: any) => (_isRef(fullScreen) ? (fullScreen).value = $event : fullScreen = $event))
                    }, _createSlots({
                      avatar: _withCtx(({avatar}) => [
                        (avatar.url)
                          ? (_openBlock(), _createBlock(OperatorAvatar, {
                              key: 0,
                              size: "5em",
                              class: "header-avatar",
                              src: avatar.url
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]),
                      hangup: _withCtx(() => [
                        _createElementVNode("button", _hoisted_8, [
                          _createVNode(SvgIcon, { "icon-name": "phone" })
                        ])
                      ]),
                      camera: _withCtx(({enabled}) => [
                        _createElementVNode("button", {
                          title: enabled ? 'Отключить камеру' : 'Включить камеру',
                          class: "circle"
                        }, [
                          _createVNode(SvgIcon, {
                            "icon-name": enabled ? 'eye' : 'eye-slash'
                          }, null, 8, ["icon-name"])
                        ], 8, _hoisted_9)
                      ]),
                      microphone: _withCtx(({enabled}) => [
                        _createElementVNode("button", {
                          title: enabled ? 'Отключить микрофон' : 'Включить микрофон',
                          class: "circle"
                        }, [
                          _createVNode(SvgIcon, {
                            "icon-name": enabled ? 'microphone' : 'microphone-slash'
                          }, null, 8, ["icon-name"])
                        ], 8, _hoisted_10)
                      ]),
                      desktop: _withCtx(({enabled}) => [
                        _createElementVNode("button", {
                          class: "circle",
                          title: enabled ? 'Остановить показ экрана' : 'Начать показ экрана'
                        }, [
                          _createVNode(SvgIcon, {
                            "icon-name": enabled ? 'video' : 'desktop'
                          }, null, 8, ["icon-name"])
                        ], 8, _hoisted_11)
                      ]),
                      fullscreen: _withCtx(({enabled}) => [
                        _createElementVNode("button", {
                          class: "circle",
                          title: enabled ? 'Свернуть' : 'Во весь экран'
                        }, [
                          _createVNode(SvgIcon, {
                            "icon-name": enabled ? 'compress-alt' : 'expand-alt'
                          }, null, 8, ["icon-name"])
                        ], 8, _hoisted_12)
                      ]),
                      noaudio: _withCtx(() => [
                        _createVNode(SvgIcon, { "icon-name": "microphone-slash" })
                      ]),
                      novideo: _withCtx(() => [
                        _createVNode(SvgIcon, { "icon-name": "eye-slash" })
                      ]),
                      _: 2
                    }, [
                      (!_unref(fullScreen))
                        ? {
                            name: "after-buttons",
                            fn: _withCtx(() => [
                              _createElementVNode("span", { onClick: minimize }, _cache[3] || (_cache[3] = [
                                _createElementVNode("button", {
                                  class: "circle",
                                  title: "Свернуть",
                                  style: {"font-weight":"bold !important"}
                                }, " _ ", -1)
                              ]))
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["call", "show-full-screen-button", "show-screen-button", "full-screen"]))
                  : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({'flex-fill': !_unref(WidgetWebRtcCall).isCallOverlayOpened()})
            }, null, 2)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})